import { ITourBuilderStorageClient } from '../../graphql/TourBuilderStorageClient';

export type TourBuilderStoreIoC = {
  storageClient: ITourBuilderStorageClient;
};


export const TourBuilderStoreIoCStudentFakeInstance: TourBuilderStoreIoC = {
  // @ts-expect-error error
  storageClient: null,
};
